import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./DirectorPage.css";

const DirectorPage = () => {
  const { language } = useLanguage();
  const t = k => getTranslation(language, k);

  return (
    <div className="dir-page nb-page-offset">
      <Navbar />

      {/* Hero */}
      <section className="dir-hero">
        <div className="dir-hero-overlay" />
        <div className="dir-hero-content">
          <div className="dir-hero-eyebrow">{t("directorsDesk")}</div>
          <h1 className="dir-hero-title">{t("directorsMessageTitle")}</h1>
          <div className="dir-hero-breadcrumb">
            <Link to="/" className="dir-breadcrumb-link">{t("home")}</Link>
            <span className="dir-breadcrumb-sep">›</span>
            <Link to="/about" className="dir-breadcrumb-link">{t("aboutUs")}</Link>
            <span className="dir-breadcrumb-sep">›</span>
            <span>{t("directorsMessageTitle")}</span>
          </div>
        </div>
      </section>

      {/* Message Section */}
      <section className="dir-section">
        <div className="dir-inner">
          <div className="dir-photo-col">
            <div className="dir-photo-frame">
              <img
                src={`${process.env.PUBLIC_URL}/ashok.png`}
                alt="Dr. Ashok Kumar"
                className="dir-photo"
              />
            </div>
            <div className="dir-sig-card">
              <strong>Dr. Ashok Kumar</strong>
              <span>{t("dirClosingTitle")}</span>
              <span>{t("dirClosingRole")}</span>
              <div className="dir-sig-badges">
                <span className="dir-badge">MD (Internal Medicine)</span>
                <span className="dir-badge">DM (Gastroenterology)</span>
              </div>
              <div className="dir-edu-list">
                <div className="dir-edu-item">
                  <span className="dir-edu-deg">MD – Internal Medicine</span>
                  <span className="dir-edu-inst">Govt. Medical College &amp; Hospital, Chandigarh</span>
                </div>
                <div className="dir-edu-item">
                  <span className="dir-edu-deg">DM – Gastroenterology</span>
                  <span className="dir-edu-inst">Dayanand Medical College &amp; Hospital, Ludhiana</span>
                </div>
              </div>
            </div>
          </div>

          <div className="dir-content-col">
            <div className="dir-quote-wrap">
              <svg viewBox="0 0 24 24" fill="#0077b6" width="44" height="44" className="dir-quote-icon">
                <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
                <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/>
              </svg>
              <blockquote className="dir-quote">"{t("directorsQuote")}"</blockquote>
            </div>

            <div className="dir-message-body">
              <p>{t("directorsMessageFull")}</p>
              <p>{t("dirMsgPara1")}</p>
              <p>{t("dirMsgPara2")}</p>
              <p>{t("dirMsgPara3")}</p>
            </div>

            <div className="dir-closing">
              <div className="dir-closing-sig">
                <strong>Dr. Ashok Kumar</strong>
                <span>{t("dirClosingTitle")}</span>
                <span>{t("dirClosingRole")}</span>
              </div>
              <a href="tel:+919996504991" className="dir-cta-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                  <rect x="3" y="4" width="18" height="18" rx="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                {t("bookAppointmentBtn")}
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default DirectorPage;
